import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotGetQuoteException extends QuoteException {

}